import { Button, Modal, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { timeCardService } from "../../../../redux/services";
import moment from "moment";

const ModalAttatchments = ({ dataDia, contrato, funcionario_id, visible, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);

    const fetchSolicitacoesJustificativa = (status = null) => {
        if (!contrato || !funcionario_id) return;

        setIsLoading(true);

        let list = [];

        const payload = {
            empresa_id: contrato.empresa_id,
            funcionario_id,
            data_inicio: moment(dataDia).format("YYYY-MM-DD"),
            data_fim: moment(dataDia).format("YYYY-MM-DD"),
            status: ['pending', 'aprovado']
        }

        if (status) payload.status = status;

        timeCardService.listarSolicitacoesJustificativa(payload).then((data) => {
            setData(data.data);
            setIsLoading(false);

        })
        .catch((data) => {
            setIsLoading(false);
            Modal.error({
                title  : "Ocorreu um erro!",
                content: String(data),
            });
        });
    }

    const columns = [
        {
            title: "Descrição",
            dataIndex: "data",
            key: "data",
            // width: 110,
            render: (_, { data, hora_inicio, hora_fim, dia_todo, tipo, sequencia, justificativa, status_aprovacao }) => 
                <div>{`Justificativa via app (${justificativa?.nome}) -
                    ${tipo === 'parcial' ? 
                    `${hora_inicio.slice(0, 5)} até ${hora_fim.slice(0, 5)}` : 
                    dia_todo ? 'Dia todo' : `Entrada ${sequencia} e Saída ${sequencia}`}
                    ${status_aprovacao === 'pending' ? ' (Pendente de aprovação)' : ''}`}
                </div>
,
            
        },
        {
            title: "Anexo",
            dataIndex: "contrato.funcionario",
            key: "file_comprovante",
            width: 90,
            ellipsis: true,
            render: (_, { file_comprovante }) => (
                <Tooltip title="Visualizar anexo">
                    <Button type="link" href={file_comprovante} target="_blank">
                    <i class="fas fa-file"></i>
                    </Button>
                </Tooltip>
            ),
        },
    ];

    useEffect(() => {
        fetchSolicitacoesJustificativa();
    }, []);

    return (
      <Modal
        visible={visible}
        title={(
          <div className="time-card-modal-header">
            <span className="time-card-modal-header-icon"><i className="fal fa-paperclip" /></span>
            <div>
              <div className="time-card-modal-title">
                Anexos <span>[{moment(dataDia).format("DD/MM/YYYY")}]</span>
              </div>
              <div className="time-card-modal-subtitle">Arquivos enviados com as justificativas feitas pelo app.</div>
            </div>
          </div>
        )}
        wrapClassName="modal-scroll"
        className="time-card-modal time-card-list-modal"
        destroyOnClose={true}
        width={800}
        onCancel={onClose}
        footer={null}
        centered
      >
        <div className="time-card-list-card">
          <Table
            loading={{
              spinning: isLoading,
              indicator: <i className="fad fa-spinner-third fa-spin fa-2x" />,
            }}
            rowKey="uuid"
            locale={{ emptyText: "Nenhum registro encontrado." }}
            columns={columns}
            dataSource={data}
            pagination={{
              pageSize : 10,
              showTotal: (total) => `${total} ${total === 1 ? "registro" : "registros"}`,
            }}
          />
        </div>
      </Modal>
    );
}

export default ModalAttatchments;